import React from 'react';
import DraggableModal from 'components/DraggableModal';

import SearchOpenPGPKeysForm from './SearchOpenPGPKeysForm';
import {openDialogOutside} from 'common/openDialogOutside';
import {DialogTypes} from 'common/names';

type SearchOpenPGPKeysDialogProps = {
   header: string;
   onClose: () => void;
};

const SearchOpenPGPKeysDialog = ({header, onClose}: SearchOpenPGPKeysDialogProps) => {
   const openOutside = React.useCallback(
      () => openDialogOutside(DialogTypes.SearchOpenPGPKeysDialog.id),
      []
   );

   return (
      <DraggableModal width={'md'} header={header} onClose={onClose} onLaunch={openOutside}>
         <SearchOpenPGPKeysForm onClose={onClose} />
      </DraggableModal>
   );
};

export default React.memo(SearchOpenPGPKeysDialog);
